import React from 'react';

import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ExploreCard from './explore/ExploreCard'

import Copyright from './furniture/Copyright'
import {useStyles}from './furniture/Dashboard-Config'
import AppBarAndDrawer from './furniture/AppBarAndDrawer'

import { useOvermind } from '../overmind';
import NewSessionLoader from './accountSelection/NewSessionLoader'

import Typography from '@material-ui/core/Typography';

export default function Explore() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  if(state.blockAccess){
    actions.updateFlag({'name':'redirectPath','payload':'/network'});
    return(<NewSessionLoader/>);
  }else{
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>

            {/* Placeholder */}
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={classes.paper}>
                <Typography variant="h6" color="primary" gutterBottom >
                  Network Visualization
                </Typography>
                <Typography variant="body1"  gutterBottom >
                  GTM Docs - Network Visualization provides an easy way to understand the interconnectedness between all your tags, triggers and variables.  Add any combination of tags, triggers and variables and watch the network render!
                </Typography>
              </Paper>
            </Grid>

            {/* Explore Graph*/}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <ExploreCard />
              </Paper>
            </Grid>


            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  }
}
